import React from 'react'
import { Menu, Icon, Layout, Row, Col, Dropdown, Avatar, Badge, Popover, List, Tabs, Tag } from 'antd'
import HeaderSearch from '../HeaderSearch/index.js';
// import NoticeIcon from '../../components/common/NoticeIcon'
import touxiangman from '../../styles/images/touxiang/touxiangman-s.png';
import touxiangwoman from '../../styles/images/touxiang/touxiangwoman-s.png';
import {userLogout} from "../../actions/login";
import NHFetch from '../../utils/NHFetch';
import {hasAuth,getLoginUser} from '../../utils/NHCore';
const { Header } = Layout
const TabPane = Tabs.TabPane;

export default class Top extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            username: '',
            userSex:'1',
            searchData:[]
        }
    }

    componentDidMount() {
        let userLogin = getLoginUser();
        //获取用户信息
        NHFetch(`api/zhxg-fwgl/fwgl/fwgl/${userLogin.userId}/getUserMsgByUserId`,'get').then(res=>{
            let userSex = '1';
            if(res && res.data){
                userSex = res.data.XBM;
            }
            this.setState({userSex,username:userLogin.userName});
        })
        //获取用户功能
        NHFetch(`api/zhxg-fwgl/fwgl/fwgl/${userLogin.userId}/getFwlbMsgByUserId`,'get').then(res=>{
            let searchData = [];
            if(res && res.data){
                searchData = res.data;
                searchData = searchData.filter(item=>hasAuth(`zhxg_fwgl_home:${item.wfwbz.toLowerCase()}`));
            }
            this.setState({searchData});
        })
    }

    userLogout = () => {
        userLogout(this.props.dispatch);
    }

    render() {
        const menu = (
            <Menu className='menu' selectedKeys={[]} onClick={this.onMenuClick}>
                {/* <Menu.Item disabled><Icon type="user" />个人中心</Menu.Item>
                <Menu.Item disabled><Icon type="setting" />设置</Menu.Item>
                <Menu.Divider /> */}
                <Menu.Item key="logout" ><a onClick={this.userLogout}><Icon type="logout" />退出登录</a></Menu.Item>
            </Menu>
        );
        
        return (
            <Header style={{ background: '#fff', padding: 0 }}>
                <Row>
                    <Col span={12}>
                        <Icon
                            className="trigger"
                            type={this.props.collapsed ? 'menu-unfold' : 'menu-fold'}
                            onClick={this.props.toggle}
                            style={{ fontSize: 20, marginLeft: 20, cursor: 'pointer' }}
                        />
                    </Col>
                    <Col span={12} style={{ textAlign: 'right' }}>
                        <HeaderSearch
                            placeholder="请输入服务名称"
                            searchData={this.state.searchData}
                        />

                        {/* <NoticeIcon /> */}

                        <Dropdown overlay={menu}>
                            <span className='action account'>
                                <Avatar size="small" className='avatar' src={this.state.userSex=='1'?touxiangman:touxiangwoman} />
                                <span className='name'>{this.state.username}</span>
                            </span>
                        </Dropdown>
                    </Col>
                </Row>
            </Header>
        )
    }
}


// WEBPACK FOOTER //
// ./containers/Header/index.js